import { render, staticRenderFns } from "./serverDetail.vue?vue&type=template&id=6806d518&scoped=true&"
import script from "./serverDetail.vue?vue&type=script&lang=js&"
export * from "./serverDetail.vue?vue&type=script&lang=js&"
import style0 from "./serverDetail.vue?vue&type=style&index=0&id=6806d518&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6806d518",
  null
  
)

export default component.exports